import request from '@/router/axios'
import env from '@/config/env'

/**
 * 查看订单联系电话
 * @param params
 */
export const viewMobile = (params) => {
  return request({
    url: env.ferryUrl + '/information-security-log/viewMobile',
    method: 'post',
    data: params
  })
}
/**
 *
 * @param params
 */
export const logSave = (params) => {
  return request({
    url: env.ferryUrl + '/information-security-log/save',
    method: 'post',
    data: params
  })
}
/**
 *
 * @param params
 */
export const updateAttachment = (params) => {
  return request({
    url: env.ferryUrl + '/information-security-log/update-attachment',
    method: 'put',
    params
  })
}
